/**
 * Les mesures Amplitude des gestes de l'activité, sous les MÊMES noms et les mêmes propriétés que
 * l'ancien code : les séries continuent d'un espace à l'autre (Amplitude plafonne les types
 * d'événements, un nom nouveau ne serait pas ingéré).
 *
 *  - `congrats.activity_finalized` : l'écran de fin d'une activité rendue s'ouvre (`CongratsScreen`,
 *    `"congrats." + congratsType`) ;
 *  - `button.clicked.<id>` : un bouton de l'ancien code qui portait un `trackingId` (`FilledButtonM`).
 *    « Mon travail » (`my_work_button`), qui ouvrait la boîte de la copie, n'a plus de bouton : la
 *    barre de copie l'a remplacé, et chaque geste de la copie (l'appareil photo, le micro) l'émet.
 *    `my_work_modal.add_photo` le suit seulement là où l'ancien passait par la boîte pour prendre une
 *    page : une activité photo qui en a déjà une (la première ouvrait l'appareil directement, et
 *    l'oral n'avait pas ce bouton). « J'ai fini » émet `my_work_modal.submit_activity` ;
 *  - `textbutton.clicked.<id>` : un bouton texte de l'ancien code (`TextButtonM`), « Continuer sans
 *    attendre » de l'attente de correction (`correction.wait.skipped`) ;
 *  - `sam.session.started` : ses propriétés, `entry_point` compris (`banner` pour la mission de
 *    l'accueil, `todo` sinon), comme l'ancien `SamSessionScreen`.
 *
 * Le bouton d'une boîte (`dialog.button.clicked`, titre et bouton en propriétés) passe par le geste commun des ports,
 * `ui/hooks/trackDialogButton`.
 */
import * as amplitude from "@amplitude/analytics-react-native"

import { type WorkMedium } from "../../../../../../engine/activity/workMedium"

export const ACTIVITY_BUTTONS = {
    myWork: "my_work_button",
    addPhoto: "my_work_modal.add_photo",
    submit: "my_work_modal.submit_activity",
} as const

export function trackCongratsShown(): void {
    amplitude.track("congrats.activity_finalized")
}

export function trackButton(trackingId: string): void {
    amplitude.track(`button.clicked.${trackingId}`)
}

/** « Continuer sans attendre » : un `TextButtonM`, qui mesurait sous son propre préfixe. */
export function trackCorrectionSkipped(): void {
    amplitude.track("textbutton.clicked.correction.wait.skipped")
}

/**
 * Un geste de la copie (l'appareil photo, le micro) : ce que l'ancien mesurait pour la même page.
 * `pageCount` compte les pages déjà prises, avant celle-ci.
 */
export function trackCopyCapture(medium: WorkMedium, pageCount: number): void {
    trackButton(ACTIVITY_BUTTONS.myWork)
    if (medium === "photo" && pageCount > 0) trackButton(ACTIVITY_BUTTONS.addPhoto)
}

/** Les propriétés de `sam.session.started`, celles de l'ancien `SamSessionScreen`. */
export function samSessionStartedProps(
    activityId: number | null,
    entryPoint: string | null | undefined,
    sourceKind: unknown
): Record<string, unknown> {
    return { activity_id: activityId, entry_point: entryPoint || "todo", source_kind: sourceKind }
}
